module.exports = __webpack_public_path__ + "fonts/Rubik-400-latin69.b65daad.woff2";